import request from '@/utils/request'


function submitOrder(data) {
  return request({
    url: `${process.env.VUE_APP_PAY_API}/wechatpay/submitorder`,
    method: 'post',
    data
  })
}

function checkOrderStatus(outTradeNo) {
  return request({
    url: `${process.env.VUE_APP_PAY_API}/wechatpay/queryorderstatus/${outTradeNo}`,
    method: 'get'
  })
}
// const cancelOrder = (id) => {
//   return request({
//     url: `${process.env.VUE_APP_PAY_API}/order/${id}/cancel-order`,
//     method: 'post',
//   })
// }

export default {
  submitOrder,
  checkOrderStatus,
  // cancelOrder,
}
